import { useAuthInitializer } from '@/core/hooks/useAuthInitializer'

/**
 * Component that initializes authentication by fetching user data once on app load
 * This component should be placed at the app root level, inside the Redux Provider
 */
export const AuthInitializer = () => {
	useAuthInitializer()
	return null
}
